import React from "react";
import useMoreBlog from "./useMoreBlog";
import NewsList from "components/news-list";
import WaveUnderline from "components/wave-underline";
import ArrowLink from "components/arrow-link";
import "./more-blog.scss";

const MoreBlog = ({ excludeIds }) => {
  const { loading, error, data } = useMoreBlog({ excludeIds });

  if (loading || error) {
    return null;
  }

  return (
    <div className="MoreBlog">
      <h2 className="MoreBlog-heading">
        <WaveUnderline>More from the Blog</WaveUnderline>
      </h2>
      <NewsList items={data.entries} />
      <ArrowLink
        className="MoreBlog-more"
        linkTo={{
          text: "See all blog",
          element: {
            uri: "blog"
          }
        }}
      />
    </div>
  );
};

export default MoreBlog;
